<template>
    <div class="text-center">
        <v-dialog persistent v-model="dialog" width="500">
            <v-card>
                <v-card-text>
                    {{message}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="clickYes">
                    {{yesText}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "Dialog",
        props: ['dialog', 'message', 'yesText'],
        methods:{
            clickYes(){
                this.$emit('clickYes');
            }
        }
    }
</script>

<style scoped>

</style>